<template>
  <v-container fluid class="px-10">
    <v-row>
      <v-col cols="5">
        <h2>Payment History</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3">
        <v-menu
          ref="menu1"
          v-model="menu1"
          offset-y
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="search.startDate"
              readonly
              v-bind="attrs"
              v-on="on"
              label="Start Date"
              prepend-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search.startDate"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="3">
        <v-menu
          ref="menu2"
          v-model="menu2"
          offset-y
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="search.endDate"
              readonly
              v-bind="attrs"
              v-on="on"
              label="End Date"
              prepend-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search.endDate"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="3">
        <v-autocomplete
          v-model="search.product"
          dense
          label="Search by product"
          :items="productList"
          class="pt-5"
        ></v-autocomplete>
      </v-col>
      <v-col cols="3">
        <v-autocomplete
          v-model="search.productVariant"
          dense
          label="Search by product variant"
          :items="productVariantList"
          class="pt-5"
        ></v-autocomplete>
      </v-col>
      <v-col cols="3">
        <v-select v-model="search.status" label="Payment Status" required :items="statusItems"> </v-select>
      </v-col>
      <v-col cols="3">
        <v-text-field v-model="search.email" label="Email"></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field v-model="search.firstName" label="First name"></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field v-model="search.lastName" label="Last name"></v-text-field>
      </v-col>
      <!-- <v-col cols="3">
        <v-autocomplete v-model="search.country" :items="countries" label="Country" item-text="title" item-value="id" />
      </v-col> -->
      <v-col cols="3">
        <v-select v-model="search.isRecurring" label="Recurring" :items="recurringOptions"> </v-select>
      </v-col>
      <v-col cols="3">
        <v-text-field v-model="search.discountCode" label="Discount Code"></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-select
          v-model="search.acquisitionTypes"
          label="Acquisition Type"
          multiple
          :items="[
            { value: 'NEW', text: 'New' },
            { value: 'RETURNING', text: 'Returning' },
            { value: 'CONTINUING', text: 'Continuing' },
            { value: 'UPGRADING', text: 'Upgrading' },
            { value: 'DOWNGRADING', text: 'Downgrading' },
          ]"
        >
        </v-select>
      </v-col>
      <v-col cols="3">
        <v-text-field v-model="search.package" label="Package"></v-text-field>
      </v-col>

      <v-col cols="3" v-if="hasSearch">
        <v-btn @click="resetFilter"> Reset Filters </v-btn>
      </v-col>

      <v-col cols="3">
        <vue-json-to-csv :json-data="dataString" csv-title="payments-export">
          <v-btn>
            Download CSV
          </v-btn>
        </vue-json-to-csv>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-simple-table>
          <thead>
            <tr>
              <th></th>
              <th class="text-left">Customer</th>
              <th class="text-left">Product</th>
              <th class="text-left">Acquisition Type</th>
              <th class="text-left">Created At</th>
              <th class="text-left">Payment Status</th>
              <th class="text-left">Recurring</th>
              <th class="text-left">Total Amount</th>
              <th class="text-left">Total Discount</th>
              <th class="text-left">Discount Code</th>
              <th class="text-left">Affiliate</th>
              <th class="text-left">Country</th>
              <!-- <th class="text-left">Package</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(payment, index) in paymentsList" :key="payment.node.id">
              <td>
                {{ index + 1 }}
              </td>
              <td>
                <router-link class="black--text font-weight-bold" :to="`/client-profile/${payment.node.order.user.id}`">
                  {{ payment.node.order.user.firstName }}
                  {{ payment.node.order.user.lastName }}
                </router-link>
                <br />
                {{ payment.node.order.user.email }}
              </td>
              <td>
                <span v-for="vari in payment.node.order.productVariants.edges" :key="vari.node.id">
                  {{ vari.node.product.title }}
                </span>
                -
                <span v-for="vari in payment.node.order.productVariants.edges" :key="vari.node.id">
                  {{ vari.node.title }}
                </span>
              </td>
              <td>
                <span v-if="payment.node.subscription && !payment.node.isRecurring">{{
                  payment.node.subscription.acquisitionType
                }}</span
                ><span v-else>&nbsp;</span>
              </td>
              <td>
                {{ payment.node.createdAt | moment("YYYY-MM-DD HH:MM") }}
              </td>
              <td>
                {{ payment.node.paymentStatus }}
              </td>
              <td>
                {{ payment.node.isRecurring ? "Recurring payment" : "First payment" }}
              </td>
              <td>
                {{ payment.node.totalAmount }}
              </td>
              <td>
                {{ payment.node.discountAmount }}
              </td>
              <td>
                {{ payment.node.discountCodes }}
              </td>
              <td>
                <span v-if="payment.node.affiliate">{{ payment.node.affiliate.code }}</span>
              </td>
              <td>
                {{ payment.node.country }}
              </td>
              <!-- <td>
                <span v-for="transaction in payment.node.transactionSet" :key="transaction.id">
                  {{ transaction.transactionStatus }} with code:
                  {{ transaction.gatewayResponse }}
                </span>
              </td> -->
              <!-- <td>
                <span v-if="payment.node.order.package">{{ payment.node.order.package.title }}</span>
              </td> -->
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <scroll-loader :loader-method="loadmore" :loader-disable="!hasNextPage"> </scroll-loader>
  </v-container>
</template>

<script>
import { PAYMENTS_PAGINATED_QUERY, ALL_PRODUCT_VARIANTS } from "@/constants/graphql/billing/payments";
import { BILLING_PRODUCTS_QUERY } from "@/constants/graphql/users/subscription";
import { countryListAlpha2 } from "@/lib/countries";
import { decodeId } from "@/lib/string";
import VueJsonToCsv from "vue-json-to-csv";

export default {
  name: "PaymentReporting",
  components: {
    VueJsonToCsv,
  },
  data() {
    return {
      paymentsList: [],
      payments: null,
      after: null,
      endCursor: "",
      loadingMore: false,
      hasNextPage: false,
      menu1: false,
      menu2: false,
      billingProducts: {},
      allProductVariants: {},
      productList: [],
      productVariantList: [],
      dataString: [],
      countries: [...countryListAlpha2],
      statusItems: [
        { value: "PROCESSING", text: "Processing" },
        { value: "FAILED", text: "Failed" },
        { value: "SUCCESS", text: "Success" },
      ],
      recurringOptions: [
        { value: null, text: "None" },
        { value: false, text: "First payment" },
        { value: true, text: "Recurring payment" },
      ],
      search: {
        startDate: null,
        endDate: null,
        isRecurring: null,
        paymentStatus: null,
        email: null,
        firstName: null,
        lastName: null,
        status: null,
        product: null,
        payment: null,
        acquisitionTypes: null,
        package: null,
      },
    };
  },
  watch: {
    search: {
      handler: function(after, before) {
        this.after = null;
        this.paymentsList = [];
        this.payments = {};
      },
      deep: true,
    },
  },
  computed: {
    hasSearch() {
      let isSearching = false;
      for (var key in this.search) {
        if (this.search[key] != null) {
          isSearching = true;
          break;
        }
      }
      return isSearching;
    },
  },
  methods: {
    getGymBranch(userProfile) {
      return userProfile.gymBranch ? userProfile.gymBranch.title : "";
    },
    loadmore() {
      this.after = this.endCursor;
    },
    resetFilter() {
      this.after = null;

      this.search = {
        startDate: null,
        endDate: null,
        isRecurring: null,
        paymentStatus: null,
        email: null,
        firstName: null,
        lastName: null,
        status: null,
        product: null,
        country: null,
      };
    },
    getId(base64string) {
      let decoded = atob(base64string).split(":");
      if (decoded[1]) return decoded[1];
      return "";
    },
  },
  apollo: {
    payments: {
      query: PAYMENTS_PAGINATED_QUERY,
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          paymentStatus: this.search.status,
          isRecurring: this.search.isRecurring,
          email: this.search.email,
          billingDate_Gte: this.search.startDate,
          billingDate_Lte: this.search.endDate,
          firstName: this.search.firstName,
          lastName: this.search.lastName,
          order_ProductVariants_ProductId: this.search.product,
          order_ProductVariants_Id: this.search.productVariant,
          discountCodeIcontains: this.search.discountCode,
          acquisitionTypeIn: this.search.acquisitionTypes,
          package: this.search.package,
          country: this.search.country,
          after: this.after,
          first: 200,
        };
      },
      result(response) {
        if (response.data && !response.loading) {
          this.loading = false;
          this.endCursor = response.data.payments.pageInfo.endCursor;
          this.hasNextPage = response.data.payments.pageInfo.hasNextPage;
          this.paymentsList = [...this.paymentsList, ...response.data.payments.edges];
        }
        if (response.error && response.error.gqlError?.message == "Permission Denied.") {
          this.$router.push("/no-access");
        }
      },
      update(data) {
        this.dataString = data.payments.edges.map((item) => {
          let product = "";
          for (let i = 0; i < item.node.order.productVariants.edges.length; i++) {
            let variant = item.node.order.productVariants.edges[i].node;
            product += `${variant.product.title} - ${variant.title}`;
          }

          let json = {
            id: decodeId(item.node.id),
            email: item.node.order.user.email,
            phone: item.node.order.user?.userProfile?.phone ?? "",
            product: product,
            totalAmount: item.node.totalAmount,
            affiliate: item.node.affiliate ? item.node.affiliate.code : "",
            suburb: item.node.order?.user?.userProfile?.suburb ?? "",
            country: item.node.order?.user?.userProfile?.country?.code ?? "",
            createdAt: item.node.createdAt,
          };
          return json;
        });
      },
    },
    billingProducts: {
      query: BILLING_PRODUCTS_QUERY,
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          response.data.billingProducts.edges.forEach((item) => {
            let data = {
              value: item.node.id,
              text: `${item.node.title}`,
            };

            this.productList.push(data);
          });
        }
        if (response.error && response.error.gqlError?.message == "Permission Denied.") {
          this.$router.push("/no-access");
        }
      },
    },
    allProductVariants: {
      query: ALL_PRODUCT_VARIANTS,
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          response.data.allProductVariants.forEach((item) => {
            let data = {
              value: item.id,
              text: `${item.product.title} - ${item.title}`,
            };

            this.productVariantList.push(data);
          });
        }
      },
    },
  },
};
</script>

<style scoped>
.fake-link {
  cursor: pointer;
}
</style>
